import getApiClient from '../../../../plugins/api'

export default function() {
    const self = this,
        api = getApiClient(self.$store),
        token = self.$route.params.token

    self.$store.commit('startLoading')

    api.get( `/password_change_tokens/${token}`)
        .then(result => {
            let tokenData = result.data
            if (tokenData.used) {
                self.$router.push('/')
                return
            }
            self.token = tokenData
        })
        .catch(() => {
            self.$router.push('/')
        })
        .finally(() => {
            self.$store.commit('stopLoading')
        })
}